module.exports = __webpack_public_path__ + "img/nav_icon_employees_dk.0f93a5f7.svg";